/**************************************************
 * Nombre:       Seccion_EquipoID
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {
    CASILLA_CODIGO_DATO,
    CASILLA_ESTADO,
    CASILLA_FECHA_DATOS,
    CASILLA_FECHA_DINERO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import React, {useEffect, useState} from "react";
import {ArrowBack, ManageSearch, Timeline} from "@mui/icons-material";
import {ESTADOSCONTRATO} from "../../Constantes";
import {useNavigate} from "react-router";
import {useParams} from "react-router-dom";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";
import FilaEquipo from "../Secciones/Componentes/FilaEquipo";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Hijo from "../Dialogos/Dialogo_Hijo";


const Seccion_EquipoID = () => {
    const navigate = useNavigate();
    const params = useParams();
    const [usuario, setUsuario] = useState({})
    const [equipo, setEquipo] = useState([])
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Hijo, titulo: 'Detalle de hijo'})

    /*if (items.length <= 0) {
        return ''
    }*/

    const recibirDatos = (hijo, nivel, hijosNivel) => {

        abrir({hijo: hijo, nivel: nivel, hijosNivel: hijosNivel, idCuenta: params.id})

    }


    useEffect(() => {

        if (params.id) {


            let id = params.id


            obtenerDoc('cuentas', id).then((dox) => {
                if (dox.res) {
                    setUsuario(dox.data)
                }
            })

            obtenerDoc('equipos', id).then((dox) => {
                if (dox.res) {
                    setEquipo(dox.data)
                }
            })


        }

    }, [params]);
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -3}}>
                    <Button
                        onClick={() => window.history.back()}
                        variant={'text'} startIcon={<ArrowBack/>}>Atras</Button>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start', mt: 0,}}>
                    <Typography sx={{fontSize: 24, fontWeight: 800}}>{`Equipo de: ${usuario.nombre}`}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        // sx={{color: '#fff'}}
                    >


                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mb: 8}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                            >

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', borderBottom: 1, pb: 2}}>
                                    <FilaEquipo items={equipo['0']} titulo={'Primero'} click={recibirDatos}
                                                nivel={'0'}/>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', borderBottom: 1, pb: 2}}>
                                    <FilaEquipo items={equipo['1']} titulo={'Segundo'} porcentaje={8}
                                                click={recibirDatos}
                                                nivel={'1'}/>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', borderBottom: 1, pb: 2}}>
                                    <FilaEquipo items={equipo['2']} titulo={'Tercero'} porcentaje={6}
                                                click={recibirDatos}
                                                nivel={'2'}/>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', borderBottom: 1, pb: 2}}>
                                    <FilaEquipo items={equipo['3']} titulo={'Cuarto'} porcentaje={4}
                                                click={recibirDatos}
                                                nivel={'3'}/>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', borderBottom: 1, pb: 2}}>
                                    <FilaEquipo items={equipo['4']} titulo={'Quinto'} porcentaje={2}
                                                click={recibirDatos}
                                                nivel={'4'}/>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', borderBottom: 1, pb: 2}}>
                                    <FilaEquipo items={equipo['5']} titulo={'Sexto'} porcentaje={1} click={recibirDatos}
                                                nivel={'5'}/>
                                </Grid>


                            </Grid>
                        </Grid>


                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Seccion_EquipoID

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]

const datosCabecera = [
    {
        nombre: '# y Nombre',
        direccion: 'left',
        propiedades: ['consecutivo', 'nombre'],
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATOS
    },
    {
        nombre: 'Correo',
        direccion: 'left',
        propiedad: 'correo',
        titulo: 'hash',
        tipo: CASILLA_CODIGO_DATO
    },
    {
        nombre: 'Inicia',
        direccion: 'left',
        propiedad: 'valor',
        fecha: 'fechaInicio',
        tipo: CASILLA_FECHA_DINERO

    },
    {
        nombre: 'Estado',
        direccion: 'right',
        propiedad: 'estado',
        tipo: CASILLA_ESTADO,
        estados: ESTADOSCONTRATO
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    },
    {
        nombre: 'Movimientos',
        id: 'movimientos',
        icono: Timeline
    }
]